module.exports = __webpack_public_path__ + "static/media/richmond-logo.5c96df9c.svg";